import type { FieldValidationRule, NumericField } from '@talos/kyoko';
import Big from 'big.js';
import type { WritableDraft } from 'immer';
import { validateQuantity } from '../NewOrder/rules';
import { getRFQCurrencyAsset } from './currencies';
import { getCareOrderQuantityValidationResult, isCareOrWorkingOrderParentType } from './tradeCareOrder';
import type { RFQState } from './types';

export const quantityValidation: FieldValidationRule<NumericField, WritableDraft<RFQState>> = (field, context) => {
  if (!context || !field.value) {
    return null;
  }

  const { form, referenceData } = context;
  const security = form?.symbolField.value;
  if (!security) {
    return null;
  }

  const quantity = new Big(field.value);
  // Contracts (units / prediction) have no request currency, so validate them with the shared contract rules.
  const orderCurrency = getRFQCurrencyAsset(form.rfqCurrencyField.value) ?? '';

  return validateQuantity(security, quantity, orderCurrency, referenceData.currencies.currenciesBySymbol);
};

export const careOrderQuantityValidation: FieldValidationRule<NumericField, WritableDraft<RFQState>> = (
  field,
  context
) => {
  const orderQty = field.value;
  if (
    context?.form.parentIDField.value == null ||
    !isCareOrWorkingOrderParentType(context.form.parentType) ||
    !context.form.assignToParentField.value ||
    !orderQty
  ) {
    return null;
  }

  return getCareOrderQuantityValidationResult({ orderQty, currentCareOrder: context?.currentCareOrder });
};
